// src/config/constants.js
// Single source of truth for all application constants

export const APP_CONFIG = {
  companyName: 'Coasthive', // TODO: Update with your company name
  tagline: 'Your All-In-One Digital Powerhouse',
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL || 'Hello@coasthive.com',
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'support@coasthive.com',
  version: '1.0.0',
};

export const BUSINESS_SIZES = [
  { value: 'small', label: '🌱 Small (1-10 employees)' },
  { value: 'medium', label: '🚀 Medium (11-50 employees)' },
  { value: 'large', label: '💎 Large (51+ employees)' },
];

export const STATS = [
  { emoji: '🌐', number: '200+', label: 'Websites Built' },
  { emoji: '❤️', number: '150+', label: 'Happy Clients' },
  { emoji: '📱', number: '500K+', label: 'Social Reach' },
  { emoji: '⚡', number: '24/7', label: 'Support' },
];

export const FEATURES = [
  {
    emoji: '🎨',
    title: 'Stunning Websites',
    description: 'Beautiful, fast, mobile-friendly sites that turn visitors into customers',
    gradient: 'from-teal-700 to-cyan-500',
  },
  {
    emoji: '📸',
    title: 'Social Media Magic',
    description: 'Viral-worthy content that builds your brand and engages your audience',
    gradient: 'from-cyan-500 to-teal-700',
  },
  {
    emoji: '🚀',
    title: 'Growth Strategy',
    description: 'Data-driven campaigns that actually grow your business and ROI',
    gradient: 'from-teal-600 to-cyan-400',
  },
  {
    emoji: '✍️',
    title: 'Content Creation',
    description: 'Eye-catching graphics, videos, and copy that stops the scroll',
    gradient: 'from-cyan-400 to-teal-700',
  },
  {
    emoji: '📊',
    title: 'Analytics & Reports',
    description: 'Clear insights showing exactly how your investment is paying off',
    gradient: 'from-teal-700 to-cyan-400',
  },
  {
    emoji: '🛠️',
    title: 'Always-On Support',
    description: "We're here 24/7 to keep everything running smoothly",
    gradient: 'from-teal-800 to-cyan-500',
  },
];

export const PRICING_PLANS = [
  {
    id: 'tier1',
    name: 'Starter',
    emoji: '🌱',
    tier: 'Tier 1',
    price: 399,
    period: '/month',
    gradient: 'from-cyan-500 to-teal-700',
    badge: 'For Small Biz',
    popular: false,
    features: [
      'Custom Website Design',
      'Mobile Responsive',
      'Monthly Maintenance',
      'SSL Security',
      'Basic SEO',
      'Email Support',
    ],
    description: 'Perfect for small businesses getting started online',
  },
  {
    id: 'tier2',
    name: 'Growth',
    emoji: '🚀',
    tier: 'Tier 2',
    price: 599,
    period: '/month',
    gradient: 'from-teal-700 to-cyan-500',
    badge: '🔥 Most Popular',
    popular: true,
    features: [
      'Everything in Starter',
      'Facebook Management',
      'Instagram Strategy',
      'Content Creation',
      'Monthly Reports',
      'Priority Support',
    ],
    description: 'For growing businesses ready to expand their reach',
  },
  {
    id: 'tier3',
    name: 'Scale',
    emoji: '💎',
    tier: 'Tier 3',
    price: 999,
    period: '/month',
    gradient: 'from-cyan-400 to-teal-700',
    badge: 'For Enterprises',
    popular: false,
    features: [
      'Everything in Growth',
      'Weekly Social Posts',
      'Ad Campaigns',
      'Influencer Outreach',
      'Advanced Analytics',
      'Dedicated Manager',
    ],
    description: 'Comprehensive solution for scaling businesses',
  },
  {
    id: 'tier4',
    name: 'Custom',
    emoji: '🎯',
    tier: 'Tier 4',
    price: null,
    priceLabel: "Let's Chat",
    period: '',
    gradient: 'from-teal-700 to-cyan-500',
    badge: 'Tailored to You',
    popular: false,
    features: [
      'Fully Customizable',
      'Unlimited Revisions',
      'Multi-Platform',
      'Brand Consulting',
      'White-Label Options',
      '24/7 Premium Support',
    ],
    description: 'Tailored solutions for unique business needs',
  },
];

export const SOCIAL_LINKS = {
  facebook: '', // TODO: Add your Facebook URL
  instagram: '', // TODO: Add your Instagram URL
  twitter: '', // TODO: Add your Twitter URL
  linkedin: '', // TODO: Add your LinkedIn URL
};

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const API_ENDPOINTS = {
  contactForm: process.env.REACT_APP_CONTACT_API_URL || `${API_BASE_URL.replace(/\/$/, '')}/api/contact`,
  subscribe: process.env.REACT_APP_SUBSCRIBE_API_URL || `${API_BASE_URL.replace(/\/$/, '')}/api/subscribe`,
};
